/**
 * Shrink `el`'s font until its text fits inside its own box (no vertical or horizontal
 * overflow). Starts from the CSS font size, so text that already fits is left alone.
 * `el` must have a bounded height (e.g. max-height: 100% inside a fixed-size box).
 */
export function fitTextToBox(el, { minPx = 8, stepPx = 0.5 } = {}) {
  if (!el) return;
  el.style.fontSize = "";
  let size = parseFloat(window.getComputedStyle(el).fontSize) || 16;
  const fits = () =>
    el.scrollHeight <= el.clientHeight + 1 && el.scrollWidth <= el.clientWidth + 1;
  while (!fits() && size > minPx) {
    size = Math.max(minPx, size - stepPx);
    el.style.fontSize = `${size}px`;
  }
}
